$(function () {

  var init = function () {
    //update reservable selectbox
    var $select = $('select[name=reservable]');
    $select.val($('#_type').val() + ':' + $('#_id').val());
    $select.trigger('select2:updated');

    //check in
    var $check_in = $('#_check_in');
    if ($check_in.length) {
      $('#reservation_check_in_date').val($check_in.val()).data('datepicker').setDate($check_in.val());
    }

    //check out
    var $check_out = $('#_check_out');
    if ($check_out.length) {
      $('#reservation_check_out_date').val($check_out.val()).data('datepicker').setDate($check_out.val());
    }
  };
  init();

  var super_refresh_data_table = window.refresh_data_table;
  window.refresh_data_table = function () {
    super_refresh_data_table(init);
  }

});
